import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  static outlets = ["message-form"]

  dispatchListing() {
    const { listingId, listingTitle } = this.buttonTarget.dataset

    this.messageFormOutlet.attachListing({ title: listingTitle, id: listingId })
    $("#listing-search-modal").modal("hide")
  }
}
